import { useEffect } from "react";
import { useTranslation } from "react-i18next";

/**
 * Imposta il <title> e la meta description della pagina, tradotti.
 * Ogni pagina dichiara la sua chiave sotto "seo" nei dizionari;
 * `valori` sono le variabili di interpolazione (es. il nome della camera).
 */
export default function TitoloPagina({ chiave, valori }) {
  const { t } = useTranslation();
  const valoriSerial = JSON.stringify(valori || {});

  useEffect(() => {
    const v = JSON.parse(valoriSerial);
    document.title = t(`seo.${chiave}.titolo`, v);

    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", t(`seo.${chiave}.descrizione`, v));
  }, [t, chiave, valoriSerial]);

  return null;
}
